import normalizeProduct from "../../utils/normalizations/normalize-product";
import { requireConfigValue } from "../../isomorphic-config";
const defaultImagesSize = requireConfigValue("imagesSize");
const defaultImagesQuality = requireConfigValue("imagesQuality");
export default function getAllProductVariantsOperation({ commerce  }) {
    async function getAllProductVariants({ variables: getAllProductVariantsVariables = {} , config: userConfig  } = {}) {
        const { taxons , imagesSize , imagesQuality , page , perPage , sort  } = getAllProductVariantsVariables;
        const filter = {
            filter: {
                taxons: taxons == null ? void 0 : taxons.toString()
            }
        };
        const variables = {
            methodPath: "products.list",
            arguments: [
                {},
                {
                    sort,
                    include: "primary_variant,variants,images,option_types,variants.option_values,product_properties",
                    page,
                    per_page: perPage || 150,
                    ...filter,
                    image_transformation: {
                        size: imagesSize || defaultImagesSize,
                        quality: imagesQuality || defaultImagesQuality
                    },
                    fields: {
                        image: "transformed_url",
                        description: "description"
                    }
                }, 
            ]
        };
        const config = commerce.getConfig(userConfig);
        const { fetch: apiFetch  } = config;
        try {
            // console.log("[getAllProductVariants] variables entrantes:", getAllProductVariantsVariables);
            const { data: spreeSuccessResponse  } = await apiFetch("__UNUSED__", {
                variables
            });
            const normalizedProducts = spreeSuccessResponse.data.map((spreeProduct)=>normalizeProduct(spreeSuccessResponse, spreeProduct));
            /* console.log("count list de spreeResponse: ", spreeSuccessResponse.meta?.count)
      console.log("Total count de spreeResponse: ", spreeSuccessResponse.meta?.total_count)
      console.log("total pages de spreeResponse: ", spreeSuccessResponse.meta?.total_pages) */ const variants = normalizedProducts.map((p)=>p.variants).flat();
            const meta = spreeSuccessResponse.meta;
            return {
                variants,
                meta
            };
        } catch (error) {
            // TO DO: improve error handling
            throw new Error("Failed to fetch product variants");
        }
    }
    return getAllProductVariants;
};
